/**
 * Hook to access PSC Widget context from the provider
 */

import { useContext } from 'react';
import { PSCContext, type PSCContextValue } from '../PSCProvider';

export function usePSCContext(): PSCContextValue {
  const context = useContext(PSCContext);

  if (!context) {
    throw new Error('usePSCContext must be used within a PSCProvider');
  }

  return context;
}
